import { cn } from "@oneleet/utils";

export const CircleDpf = ({ className }: { className?: string }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("size-6", className)}
    >
      <g clipPath="url(#clip0_2299_33427)">
        <rect width="24" height="24" rx="12" fill="white" />
        <path
          d="M8.21841 10.14C9.59841 10.14 10.3724 10.908 10.3724 12.276C10.3724 13.638 9.61041 14.4 8.25441 14.4H6.74841V10.14H8.21841ZM7.66041 13.632H8.21841C9.04641 13.632 9.44241 13.194 9.44241 12.27C9.44241 11.346 9.04641 10.908 8.21841 10.908H7.66041V13.632ZM12.437 10.14C13.457 10.14 14.075 10.668 14.075 11.532C14.075 12.396 13.457 12.93 12.437 12.93H11.645V14.4H10.733V10.14H12.437ZM11.645 12.162H12.383C12.863 12.162 13.139 11.946 13.139 11.532C13.139 11.118 12.863 10.908 12.383 10.908H11.645V12.162ZM14.5184 10.14H17.4584V10.908H15.4304V11.94H17.3504V12.696H15.4304V14.4H14.5184V10.14Z"
          fill="#CA2A30"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.25 0.75H12.75L13.8 1.80001H21.45H22.2V2.55001V10.2L23.25 11.25V0.75ZM0.75 0H12H23.25H24V0.75V23.25V24H23.25H0.75H0V23.25V0.75V0H0.75ZM10.2 1.80001L11.25 0.75H0.75V11.25L1.79998 10.2V2.55001V1.80001H2.54998H10.2ZM0.75 23.25V12.7499L1.79998 13.7999V21.45V22.2H2.54998H10.2001L11.2501 23.25H0.75ZM2.54998 21.45V14.5499L3.60001 15.6V19.65V20.4H4.35001H8.40006L9.45006 21.45H2.54998ZM3.59998 14.5393L3.60001 9.46062L3.59998 9.45L1.04998 12L3.59998 14.55V14.5393ZM4.35001 19.65V16.35L7.65006 19.65H4.35001ZM4.35001 15.2893L8.71068 19.65H15.2893L19.65 15.2893V8.71068L15.2894 4.35001H8.71062L4.35001 8.71062V15.2893ZM14.5499 21.45L15.5999 20.4H19.65H20.4V19.65V15.5999L21.45 14.55V21.45H14.5499ZM16.3499 19.65L19.65 16.3499V19.65H16.3499ZM21.45 9.45L20.4 8.4V4.35001V3.60001H19.65H15.6L14.55 2.55001H21.45V9.45ZM19.65 7.65L16.35 4.35001H19.65V7.65ZM9.46068 3.60001L14.5394 3.60001L14.5499 3.60001L11.9999 1.05001L9.44994 3.60001H9.46068ZM9.45 2.55001L8.4 3.60001H4.35001H3.60001V4.35001V8.4L2.54998 9.45V2.55001H9.45ZM7.65 4.35001L4.35001 7.65V4.35001H7.65ZM22.2 21.45V13.8L23.25 12.7499V23.25H12.7499L13.7999 22.2H21.45H22.2V21.45ZM22.95 12L20.4 14.55V9.45L22.95 12ZM9.45 20.4L12 22.95L14.55 20.4H9.45ZM21.9 12L21 12.9V11.1L21.9 12ZM11.1 21L12 21.9L12.9 21H11.1ZM2.10001 12L3.00001 11.1V12.9L2.10001 12ZM12.9023 2.99999L12.0023 2.10234L11.1023 2.99999H12.9023Z"
          fill="#0067D6"
        />
      </g>
      <rect
        x="0.3"
        y="0.3"
        width="23.4"
        height="23.4"
        rx="11.7"
        stroke="#0067D6"
        strokeWidth="0.6"
      />
      <defs>
        <clipPath id="clip0_2299_33427">
          <rect width="24" height="24" rx="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
